/**
 * @generated SignedSource<<0201609c05929637dac3bbfec0383d62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionAdsCollection$data = {
  readonly advertZone: string | null | undefined;
  readonly entityId: string;
  readonly " $fragmentType": "topicCollectionAdsCollection";
};
export type topicCollectionAdsCollection$key = {
  readonly " $data"?: topicCollectionAdsCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionAdsCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionAdsCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "version",
          "value": 2
        }
      ],
      "kind": "ScalarField",
      "name": "advertZone",
      "storageKey": "advertZone(version:2)"
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "f2a7795b819aa84a9d7d61efc837200b";

export default node;
